import { ICellRendererParams } from "ag-grid-community";
import React from "react";
import { formatCurrency } from "../../../../libs/utils";
import { YesNo } from "../../types";
import { UnitGridData } from "../types";

export const rentCellRenderer =
  (installments: number, furnished: YesNo = "NO") =>
  (params: ICellRendererParams<UnitGridData>) => {
    const paymentPlans = params?.data?.record?.paymentPlan ?? [];

    const rent = paymentPlans.find((item) => {
      return Number(item?.installments) === installments && item?.furnished?.toLowerCase() === furnished.toLowerCase();
    });

    if (!rent) return "--";
    return <p style={{ margin: 0 }}>{formatCurrency(rent.annualRent)}</p>;
  };
